import { useRouter } from 'next/router';
import { useContext } from 'use-context-selector';
import { localesWithBazaarVoice, storeLocale } from '@/root/constants';
import { ProductContext } from 'components/productContext/ProductProvider';
import globalStyles from 'styles/globalStyles';
import { BvReviews } from '../bv/bv-reviews';
import styles from './ProductReviews.module.scss';
const ProductReviews = () => {
  /* Load Product Context */
  const productContext = useContext(ProductContext);

  /* Throw Error if Context is not loaded */
  if (productContext === undefined)
    throw new Error('ProductReviews must be used within a ProductContext');

  /* Destructure all used variables from product context */
  const { isLoading, handle } = productContext;
  const { locale: routerLocale } = useRouter();
  const locale = storeLocale(routerLocale);

  // BazaarVoice configuration
  const shouldLoadBvScript = localesWithBazaarVoice.includes(locale);
  if (!shouldLoadBvScript) {
    return null;
  }

  return (
    <div className={[styles.productReviews, 'container'].join(' ')}>
      {isLoading && (
        <div
          className={[
            globalStyles.isLoading,
            styles.productReviews__loading,
          ].join(' ')}
        ></div>
      )}
      {!isLoading && <BvReviews slug={handle} />}
    </div>
  );
};

export default ProductReviews;
